import { isAndroid, isMacApp, isWinApp, isWeMeetApp, isIPhone, isIpad } from '@tencent/web-base';
import { isVisionPro, isHuawei } from './os';
import { getAppInstanceId } from './get-app-instance-id';

/**
 终端类型定义
 enum InstanceType {
  kInstanceTypeNone         = 0,
  kInstanceTypeWin          = 1,    // PC - windows
  kInstanceTypeMac          = 2,    // Mac
  kInstanceTypeAndroid      = 3,    // Android
  kInstanceTypeIPhone       = 4,    // iPhone
  kInstanceTypeWeb          = 5,    // web
  kInstanceTypeIPad         = 6,    // iPad
  kInstanceTypeAPad         = 7,    // aPad
  kInstanceTypeMiniProgram  = 8,    // wechat mini program
  kInstanceTypeVisionPro    = 12，  // vision pro
  kInstanceTypeHarmonyStart = 80,   // 鸿蒙开始
  kInstanceTypeHarmonyMobile= 81,   // 鸿蒙移动端
  kInstanceTypeHarmonyPad   = 82,   // 鸿蒙pad
  kInstanceTypeHarmonyPC    = 83,   // 鸿蒙pc
  kInstanceTypeHarmonyCar   = 84,   // 鸿蒙车机
  kInstanceTypeHarmonyWear  = 85,   // 鸿蒙穿戴
  kInstanceTypeHarmonyVR    = 86,   // 鸿蒙vr
  kInstanceTypeHarmonyEnd   = 90,   // 鸿蒙结束
};
 */

/**
 * Instance Id定义映射
 */
export const InstanceTypeMap: { [key: number]: string } = {
  0: 'None',
  1: 'Windows',
  2: 'Mac',
  3: 'Android',
  4: 'iPhone',
  5: 'Web',
  6: 'iPad',
  7: 'aPad',
  8: 'wxProgram',
  12: 'VisionPro',
  81: 'HarmonyMobile',
  82: 'HarmonyPad',
  83: 'HarmonyPC',
  84: 'HarmonyCar',
  85: 'HarmonyWear',
  86: 'HarmonyVR',
};

/**
 * 判断终端平台类型
 * @param userAgent UA
 */
export default function getInstanceId(userAgent: string): { id: number; name: string } {
  let id = 0;
  if (isWinApp(userAgent)) {
    id = 1;
  } else if (isMacApp(userAgent)) {
    id = 2;
  } else if (isAndroid(userAgent) && isWeMeetApp(userAgent)) {
    id = 3;
  } else if (isIPhone(userAgent) && isWeMeetApp(userAgent)) {
    id = 4;
  } else if (!isWeMeetApp(userAgent)) {
    id = 5;
  } else if (isIpad(userAgent) && isWeMeetApp(userAgent)) {
    id = 6;
  } else if (isVisionPro(userAgent) && isWeMeetApp(userAgent)) {
    id = 12;
  } else if (isHuawei(userAgent) && isWeMeetApp(userAgent)) {
    id = 81;
  } else if (isWeMeetApp(userAgent)) {
    id = getAppInstanceId(userAgent);
  }
  return {
    id,
    name: InstanceTypeMap[id] || '',
  };
}
